// removed by extract-text-webpack-plugin
module.exports = {"vpPreviewContainer":"vpPreviewContainer___1WRBR","vpVideoPreview":"vpVideoPreview___1FDHS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoPreview.module.less
// module id = 3468
// module chunks = 29